import { BreakpointValues } from "@material-ui/core/styles/createBreakpoints";

export type OptionalBreakpointValues = {
  readonly [K in keyof BreakpointValues]?:
    | BreakpointValues[K]
    | string
    | undefined;
};

export type GenericOptionalBreakpointValues<T> = {
  readonly [K in keyof BreakpointValues]?: T;
};

type ClassesProps = {
  readonly [key: string]:
    | string
    | number
    | OptionalBreakpointValues
    | undefined;
};

function isOptionalBreakpoint(
  props: string | number | OptionalBreakpointValues
): props is OptionalBreakpointValues {
  return typeof props === "object";
}

export const parseClasses = (props: ClassesProps): Set<string> => {
  const parsedClasses = new Set<string>();

  for (const [key, value] of Object.entries(props)) {
    const parsedValue = value;

    if (typeof parsedValue === "undefined") {
      continue;
    }

    if (isOptionalBreakpoint(parsedValue)) {
      for (const [breakpointKey, breakpointValue] of Object.entries(
        parsedValue
      )) {
        parsedClasses.add([key, breakpointKey, breakpointValue].join("_"));
      }

      continue;
    }

    parsedClasses.add([key, parsedValue].join("_"));
  }

  return parsedClasses;
};

const parseStyles = (classes: Set<string>) => {
  let parsedStyles: Array<string> = [];

  for (const elClass of classes.values()) {
    parsedStyles = [...parsedStyles, elClass];
  }

  return parsedStyles;
};

export const generateClasses = (props: ClassesProps): string[] =>
  parseStyles(parseClasses(props));
